module.exports = __webpack_public_path__ + "static/Mindfulness-1-9af3b740bb0b97430b3441b152864be2.png";